// extracted by mini-css-extract-plugin
export default {"RenameDesignForm":"PaymentSuccess_RenameDesignForm__jjQyv","modalButton":"PaymentSuccess_modalButton__onrUm"};